// extracted by mini-css-extract-plugin
export default {"body":"overview_body__Kwaqi","cancel_button":"overview_cancel_button__ht1se"};